import React from "react";
import PropTypes from "prop-types";
import CmsMarkdown from "../../basic/cms-markdown";
import CmsLink from "../../links/cms-link";

import { hero, hero_content, text_container, image_container } from "./styles.module.scss";

const HeroSideBySide = (props) => {
  const { content, background_img, button } = props;
  return (
    <div className={`cms-hero ${hero}`}>
      <div className={hero_content}>
        <div className={text_container}>
          <CmsMarkdown content={content} />
          <CmsLink link={button} classnames={["btn", "f3", "mt-2"]} />
        </div>

        <div
          className={image_container}
          style={{ backgroundImage: `url(${background_img?.data?.attributes?.url})` }}
        ></div>
      </div>
    </div>
  );
};

HeroSideBySide.propTypes = {
  content: PropTypes.node,
  background_img: PropTypes.object,
  button: PropTypes.object
};

export default HeroSideBySide;
